<div class="loader" *ngIf="isModulesLoading">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>
<div class="container" *ngIf="!isModulesLoading">
  <div class="header">
    <h2>{{'reporting.MODULES' | transloco}}</h2>
    <div class="cta" (click)="toggleOldModules()" *ngIf="remainingModules > 0">
      {{toggleString}}
      <img [src]="ctaImg">
    </div>
  </div>
  <div class="body">
    <div class="modules-card" *ngFor="let module of (modulesList | slice:0:(!showAllModules ? 4 : modulesList.length))">
      <div class="module-details">
        <h4>{{module.moduleName}}</h4>
        <div class="call-details">
          <p>
            <span>
              {{ module.callCount }} 
              {{ module.callCount === 1 ? ('reporting.CALL' | transloco) : ('reporting.CALLS' | transloco) }}.
            </span>
            <ng-container *ngIf="module.certificationAssignmentCount > 0 || module.practiceAssignmentCount > 0">
              <span *ngIf="module.certificationAssignmentCount > 0">
                {{ module.certificationAssignmentCount }} {{ module.certificationAssignmentCount === 1 ? ('reporting.CERTIFICATION_ASSIGNMENT' | transloco) : ('reporting.CERTIFICATION_ASSIGNMENTS' | transloco) }} </span>
              <span *ngIf="module.certificationAssignmentCount > 0 && module.practiceAssignmentCount > 0"> {{'reporting.AND' | transloco}} </span>
              <span *ngIf="module.practiceAssignmentCount > 0">
                {{ module.practiceAssignmentCount }} {{ module.practiceAssignmentCount === 1 ? ('reporting.PRACTICE_ASSIGNMENT' | transloco) :
                ('reporting.PRACTICE_ASSIGNMENTS' | transloco) }} </span>
            </ng-container>
          </p>
        </div>
      </div>

      <div class="cta" (click)="navigateToRoute(module!)"> {{'reporting.VIEW_ENGAGEMENT_DETAILS' | transloco}} <img
          src="/assets/icons/arrow/qnt-nav-away.svg"></div>
    </div>
  </div>
</div>